import React, { useState } from 'react';
import { useLanguage } from '../i18n/LanguageContext';

const LanguageSelector = () => {
  const { language, changeLanguage, supportedLanguages } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="relative">
      <button 
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-1 md:gap-2 px-2 md:px-3 py-1 md:py-1.5 rounded-lg transition-all hover:scale-105"
        style={{
          background: 'rgba(255,215,0,0.1)',
          border: '1px solid rgba(255,215,0,0.3)',
        }}
      >
        <span className="text-base md:text-lg">{supportedLanguages.find(l => l.code === language)?.flag}</span>
        <span className="text-xs md:text-sm font-medium hidden md:inline" style={{ color: '#ffd700' }}>
          {language.toUpperCase()}
        </span>
        <span className="text-xs" style={{ color: '#ffd700' }}>▼</span>
      </button>
      
      {/* Dropdown */}
      {isOpen && (
        <>
          {/* Backdrop to close dropdown */}
          <div 
            className="fixed inset-0 z-40"
            onClick={() => setIsOpen(false)}
          />
          <div 
            className="absolute top-full right-0 mt-2 rounded-xl overflow-hidden z-50"
            style={{
              background: 'linear-gradient(145deg, #1a1a2e, #16213e)',
              border: '1px solid rgba(255,215,0,0.3)',
              boxShadow: '0 10px 40px rgba(0,0,0,0.5)',
              minWidth: '140px'
            }}
          >
            {supportedLanguages.map((lang) => (
              <button
                key={lang.code}
                onClick={() => {
                  changeLanguage(lang.code);
                  setIsOpen(false);
                }}
                className={`w-full flex items-center gap-3 px-3 md:px-4 py-2.5 md:py-3 transition-all hover:bg-white/10 ${
                  language === lang.code ? 'bg-white/5' : ''
                }`}
              >
                <span className="text-lg md:text-xl">{lang.flag}</span>
                <span 
                  className="text-xs md:text-sm font-medium"
                  style={{ color: language === lang.code ? '#ffd700' : '#ccc' }}
                >
                  {lang.name}
                </span>
                {language === lang.code && (
                  <span className="ml-auto text-green-400 text-sm">✓</span>
                )}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default LanguageSelector;
